/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupmoveup2Inputs */

const en_signupmoveup2 = /** @type {(inputs: Signupmoveup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

const de_signupmoveup2 = /** @type {(inputs: Signupmoveup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach oben`)
};

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Signupmoveup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupmoveup2 = /** @type {((inputs?: Signupmoveup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupmoveup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupmoveup2(inputs)
	return de_signupmoveup2(inputs)
});
export { signupmoveup2 as "signupMoveUp" }